import React from 'react'
import ReactDOM from 'react-dom/client'
import KeevoWebsite from './App'
import FampoPage from './FampoPage'
import FampoResourcePage from './FampoResourcePage'
import SeoLandingPage from './SeoLandingPage'
import NotFoundPage from './NotFoundPage'
import './index.css'

const pathname = window.location.pathname

const homePaths = new Set(['/', '/en', '/en/'])

const fampoPaths = new Set([
  '/fampo',
  '/fampo/',
  '/en/fampo',
  '/en/fampo/',
])

const fampoResourcePaths = new Set([
  '/fampo/support',
  '/fampo/support/',
  '/fampo/privacy',
  '/fampo/privacy/',
  '/fampo/delete-account',
  '/fampo/delete-account/',
  '/en/fampo/support',
  '/en/fampo/support/',
  '/en/fampo/privacy',
  '/en/fampo/privacy/',
  '/en/fampo/delete-account',
  '/en/fampo/delete-account/',
])

const seoLandingPaths = new Set([
  '/apputveckling',
  '/apputveckling/',
  '/digitalisering',
  '/digitalisering/',
  '/ai-automation',
  '/ai-automation/',
  '/om-keevo',
  '/om-keevo/',
  '/en/app-development',
  '/en/app-development/',
  '/en/digitization',
  '/en/digitization/',
  '/en/ai-automation',
  '/en/ai-automation/',
  '/en/about',
  '/en/about/',
])

let page: React.ReactNode

if (homePaths.has(pathname)) {
  page = <KeevoWebsite />
} else if (fampoPaths.has(pathname)) {
  page = <FampoPage />
} else if (fampoResourcePaths.has(pathname)) {
  page = <FampoResourcePage />
} else if (seoLandingPaths.has(pathname)) {
  page = <SeoLandingPage />
} else {
  page = <NotFoundPage />
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {page}
  </React.StrictMode>,
)
